var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g({class:['form-button', {outline: _vm.outline, transparent: _vm.transparent}, _vm.className],attrs:{"type":_vm.type}},Object.assign({}, _vm.$listeners)),[_vm._t("default",[_vm._v("Click me")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }